import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getPendingEntries = createAsyncThunk('payment/pendingEntries', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/invoice/get-admin-invoices`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPaidEntries = createAsyncThunk('payment/paidEntries', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/invoice/get-admin-invoices`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getFailedEntries = createAsyncThunk('payment/failedEntries', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/invoice/get-admin-invoices`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getInvoiceOffData = createAsyncThunk('payment/invoice-off', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/invoice/get-admin-invoices`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const retryPayment = createAsyncThunk('payment/retryPayment', async (invoiceId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/invoice/retry-payment/${invoiceId}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getExitsData = createAsyncThunk('payment/exists', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaner-log/get-cleaner-log-admin`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allPendingEntries: [],
  allPaidEntries: [],
  allFailedEntries: [],
  allInvoiceOffEntries: [],
  allExitsData: [],
  error: null
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPendingEntries.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPendingEntries.fulfilled, (state, action) => {
        state.isLoading = false
        state.allPendingEntries = action.payload?.data?.data
      })
      .addCase(getPendingEntries.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getPaidEntries.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPaidEntries.fulfilled, (state, action) => {
        state.isLoading = false
        state.allPaidEntries = action.payload?.data?.data
      })
      .addCase(getPaidEntries.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getFailedEntries.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getFailedEntries.fulfilled, (state, action) => {
        state.isLoading = false
        state.allFailedEntries = action.payload?.data?.data
      })
      .addCase(getFailedEntries.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getInvoiceOffData.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getInvoiceOffData.fulfilled, (state, action) => {
        state.isLoading = false
        state.allInvoiceOffEntries = action.payload?.data?.data
      })
      .addCase(getInvoiceOffData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getExitsData.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getExitsData.fulfilled, (state, action) => {
        state.isLoading = false
        state.allExitsData = action.payload?.data?.data
      })
      .addCase(getExitsData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default paymentSlice.reducer
